import React from "react";
import PropTypes from "prop-types";

const IdUserIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M13.334 8.33301H15.0007"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 11.667H15.0007"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.14258 12.5005C5.49464 11.4997 6.44001 10.8301 7.50091 10.8301C8.56182 10.8301 9.50719 11.4997 9.85924 12.5005"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83398 9.16667C5.83398 10.0865 6.58079 10.8333 7.50065 10.8333C8.42051 10.8333 9.16732 10.0865 9.16732 9.16667C9.16732 8.24681 8.42051 7.5 7.50065 7.5C6.58079 7.5 5.83398 8.24681 5.83398 9.16667V9.16667"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33268 4.16699H16.666C17.5865 4.16699 18.3327 4.91318 18.3327 5.83366V14.167C18.3327 15.0875 17.5865 15.8337 16.666 15.8337H3.33268C2.41221 15.8337 1.66602 15.0875 1.66602 14.167V5.83366C1.66602 4.91318 2.41221 4.16699 3.33268 4.16699V4.16699"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IdUserIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

IdUserIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default IdUserIcon;
